/**
 * Application Route Configuration
 *
 * Each route defines:
 *  - path        : URL path
 *  - element     : Component to render
 *  - isPrivate   : (optional) protect route using <ProtectedRoute />
 *
 * NOTE:
 *  - Keep paths lowercase and hyphen-separated (recommended convention)
 *  - Keep component names PascalCase
 */

/*import { Home } from "./components/Home/Home";*/
import { Sidebar } from "./components/Shared/Sidebar";
import { SidebarData } from "./components/Shared/SidebarData";

import { Dashboard } from "./components/Dashboard/Dashboard";
import { Login } from "./components/Account/Login";
import { Logout } from "./components/Account/Logout";

import { RobotsOperation } from "./components/RobotOperation/RobotsOperation";
import { RobotOperation } from "./components/RobotOperation/RobotOperation";
import { PlantRobotOperation } from "./components/RobotOperation/PlantRobotOperation";
import { PlantRobotsOperationStatus } from "./components/RobotOperation/PlantRobotsOperationStatus";
import { RobotLocation } from "./components/RobotOperation/RobotLocation";
import { MapComponent } from "./components/RobotOperation/MapComponent";
import { DistanceCalculator } from "./components/RobotOperation/DistanceCalculator";
import { TestMap } from "./components/RobotOperation/TestMap";
import { TestMap1 } from "./components/RobotOperation/TestMap1";
import { RobotTaskSchedule } from "./components/RobotOperation/RobotTaskSchedule";
import { RobotTaskFields } from "./components/RobotOperation/RobotTaskFields";
import { FieldRowsMap } from "./components/RobotOperation/FieldRowsMap";

import { PlantRobotsBroadcastStatus } from "./components/Monitoring/PlantRobotsBroadcastStatus";
import { CurrentCommandStatus } from "./components/Monitoring/CurrentCommandStatus";
import { CompletedCommandsStatus } from "./components/Monitoring/CompletedCommandsStatus";
import { PendingCommandsStatus } from "./components/Monitoring/PendingCommandsStatus";
import { CurrentBatteryStatus } from "./components/Monitoring/CurrentBatteryStatus";
import { CurrentPlantLevelGrassCutting } from "./components/Monitoring/CurrentPlantLevelGrassCutting";
import { ChartCurrentGrassCuttingSpraying } from "./components/Monitoring/ChartCurrentGrassCuttingSpraying";
import { ChartCurrentPlantLevelGrassCutting } from "./components/Monitoring/ChartCurrentPlantLevelGrassCutting";
import { ChartGrassCuttingByMonths } from "./components/Monitoring/ChartGrassCuttingByMonths";
import { ChartGrassCuttingByHours } from "./components/Monitoring/ChartGrassCuttingByHours";
import { CurrentPlantLevelSpraying } from "./components/Monitoring/CurrentPlantLevelSpraying";
import { ChartCurrentPlantLevelSpraying } from "./components/Monitoring/ChartCurrentPlantLevelSpraying";
import { ChartSprayingByMonths } from "./components/Monitoring/ChartSprayingByMonths";
import { ChartSprayingByHours } from "./components/Monitoring/ChartSprayingByHours";
import { CurrentRobotLevelGrassCutting } from "./components/Monitoring/CurrentRobotLevelGrassCutting";
import { ChartCurrentRobotLevelGrassCutting } from "./components/Monitoring/ChartCurrentRobotLevelGrassCutting";
import { CurrentRobotLevelSpraying } from "./components/Monitoring/CurrentRobotLevelSpraying";
import { ChartCurrentRobotLevelSpraying } from "./components/Monitoring/ChartCurrentRobotLevelSpraying";
import { ErrorLog } from "./components/Monitoring/ErrorLog";
import { SatelliteMap } from "./components/Monitoring/SatelliteMap";
import { SatelliteData } from "./components/Monitoring/SatelliteData";
import { AgriFieldMap } from "./components/Monitoring/AgriFieldMap";
import { AgriFieldMaping } from "./components/Monitoring/AgriFieldMaping";
import { BhuAgriMap } from "./components/Monitoring/BhuAgriMap";
import { AgriDashboard } from "./components/Monitoring/AgriDashboard";
import { BhuPilot } from "./components/Monitoring/BhuPilot";
import { PiViewer }  from "./components/WEBRTC/PiViewer";
import { Broadcaster } from "./components/WEBRTC/Broadcaster";

import { Plant } from "./components/Account/Plant";
import { AddPlant } from "./components/Account/AddPlant";
import { EditPlant } from "./components/Account/EditPlant";
import { SearchPlant } from "./components/PlantEquipmentSetup/SearchPlant";

import { PlantRobot } from "./components/PlantEquipmentSetup/PlantRobot";
import { SearchRobot } from "./components/PlantEquipmentSetup/SearchRobot";

import { PlantBlock } from "./components/PlantEquipmentSetup/PlantBlock";
import { SearchBlock } from "./components/PlantEquipmentSetup/SearchBlock";

import { PlantRow } from "./components/PlantEquipmentSetup/PlantRow";
import { SearchRow } from "./components/PlantEquipmentSetup/SearchRow";

import { PlantController } from "./components/PlantEquipmentSetup/PlantController";
import { SearchController } from "./components/PlantEquipmentSetup/SearchController";

import { BlockRows } from "./components/PlantEquipmentLinking/BlockRows";
import { SearchBlockRows } from "./components/PlantEquipmentLinking/SearchBlockRows";
import { BlockControllers } from "./components/PlantEquipmentLinking/BlockControllers";
import { SearchBlockControllers } from "./components/PlantEquipmentLinking/SearchBlockControllers";
import { BlockRobots } from "./components/PlantEquipmentLinking/BlockRobots";
import { SearchBlockRobots } from "./components/PlantEquipmentLinking/SearchBlockRobots";

import { Farm } from "./components/Account/Farm";
import { AddFarm } from "./components/Account/AddFarm";
import { EditFarm } from "./components/Account/EditFarm";
import { SearchFarm } from "./components/Account/SearchFarm";

import { UploadFiles } from "./components/Admin/UploadFiles";
import { FileUploader } from "./components/Admin/FileUploader";

import RobotControl from './components/Joystick/Index';
import AgriIntelMasterControl from './components/Monitoring/AgriIntelMasterControl';
import AgriCommandCenter from './components/Monitoring/AgriCommandCenter';
import AgriCommandCenterV2 from './components/Monitoring/AgriCommandCenterV2';
import Home from './components/Home/Home';   // match the casing of your other imports
const AppRoutes = [
    // ---------------- AUTH ----------------
    // ---------------- PUBLIC ----------------
    { path: "/", element: <Login />, isPrivate: false },


    { index: true, path: "/Home", element: <Home />, isPrivate: true },

    //{
    //    path: "/",
    //    element: <Home />,
    //    isPrivate: false,
    //},
    //{
    //    path: "/login",
    //    element: <Login />,
    //    isPrivate: false,
    //},

    //{
    //    index: true,
    //    path: "/login",
    //    element: <Login />,
    //    isPrivate: false,
    //},

    // ---------------- MAP / GEO ----------------
    { path: "/map-component", element: <MapComponent /> },
    { path: "/robot-location", element: <RobotLocation />, isPrivate: true },
    { path: "/distance-calculator", element: <DistanceCalculator /> },
    { path: "/test-map", element: <TestMap /> },
    { path: "/test-map-1", element: <TestMap1 /> },

    // ---------------- ROBOT OPERATIONS ----------------
    { path: "/robots-operation", element: <RobotsOperation />, isPrivate: true },
    { path: "/robot-operation", element: <RobotOperation />, isPrivate: true },
    { path: "/plant-robot-operation", element: <PlantRobotOperation /> },

    // ---------------- MONITORING ----------------
    { path: "/robots-broadcast-status", element: <PlantRobotsBroadcastStatus />, isPrivate: true },
    { path: "/plant-robots-opn-status", element: <PlantRobotsOperationStatus />, isPrivate: true },
    { path: "/current-command-status", element: <CurrentCommandStatus />, isPrivate: true },
    { path: "/pending-commands-status", element: <PendingCommandsStatus />, isPrivate: true },
    { path: "/completed-commands-status", element: <CompletedCommandsStatus />, isPrivate: true },
    { path: "/current-battery-status", element: <CurrentBatteryStatus />, isPrivate: true },
    { path: "/agri-master-control", element: <AgriIntelMasterControl />, isPrivate: true },
    { path: "/agri-command-center", element: <AgriCommandCenter />, isPrivate: true },
    { path: "/agri-command-centerv2", element: <AgriCommandCenterV2 />, isPrivate: true },
    // Charts / Statistics
    { path: "/current-plant-level-grass-cutting", element: <CurrentPlantLevelGrassCutting />, isPrivate: true },
    { path: "/chart-current-grass-cutting-spraying", element: <ChartCurrentGrassCuttingSpraying />, isPrivate: true },
    { path: "/chart-current-plant-level-grass-cutting", element: <ChartCurrentPlantLevelGrassCutting />, isPrivate: true },
    { path: "/chart-grass-cutting-months", element: <ChartGrassCuttingByMonths />, isPrivate: true },
    { path: "/chart-grass-cutting-hours", element: <ChartGrassCuttingByHours />, isPrivate: true },
    { path: "/current-plant-level-spraying", element: <CurrentPlantLevelSpraying />, isPrivate: true },
    { path: "/chart-current-plant-level-spraying", element: <ChartCurrentPlantLevelSpraying />, isPrivate: true },
    { path: "/chart-spraying-months", element: <ChartSprayingByMonths />, isPrivate: true },
    { path: "/chart-spraying-hours", element: <ChartSprayingByHours />, isPrivate: true },
    { path: "/current-robot-level-grass-cutting", element: <CurrentRobotLevelGrassCutting />, isPrivate: true },
    { path: "/chart-current-robot-level-grass-cutting", element: <ChartCurrentRobotLevelGrassCutting />, isPrivate: true },
    { path: "/current-robot-level-spraying", element: <CurrentRobotLevelSpraying />, isPrivate: true },
    { path: "/chart-current-robot-level-spraying", element: <ChartCurrentRobotLevelSpraying />, isPrivate: true },

    { path: "/error-log", element: <ErrorLog />, isPrivate: true },

    // ---------------- ACCOUNT / PLANTS / FARMS ----------------
    { path: "/dashboard", element: <Dashboard />, isPrivate: true },

    { path: "/plant", element: <Plant />, isPrivate: true },
    { path: "/add-plant", element: <AddPlant />, isPrivate: true },
    { path: "/edit-plant", element: <EditPlant />, isPrivate: true },
    { path: "/search-plant", element: <SearchPlant />, isPrivate: true },

    { path: "/plant-robot", element: <PlantRobot />, isPrivate: true },
    { path: "/search-robot", element: <SearchRobot />, isPrivate: true },

    { path: "/farm", element: <Farm />, isPrivate: true },
    { path: "/add-farm", element: <AddFarm />, isPrivate: true },
    { path: "/edit-farm", element: <EditFarm />, isPrivate: true },
    { path: "/search-farm", element: <SearchFarm />, isPrivate: true },

    // ---------------- EQUIPMENT SETUP / LINKING ----------------
    { path: "/plant-block", element: <PlantBlock />, isPrivate: true },
    { path: "/search-block", element: <SearchBlock />, isPrivate: true },
    { path: "/plant-row", element: <PlantRow />, isPrivate: true },
    { path: "/search-row", element: <SearchRow />, isPrivate: true },
    { path: "/plant-controller", element: <PlantController />, isPrivate: true },
    { path: "/search-controller", element: <SearchController />, isPrivate: true },

    { path: "/block-rows", element: <BlockRows />, isPrivate: true },
    { path: "/search-block-rows", element: <SearchBlockRows />, isPrivate: true },
    { path: "/block-controllers", element: <BlockControllers />, isPrivate: true },
    { path: "/search-block-controllers", element: <SearchBlockControllers />, isPrivate: true },
    { path: "/block-robots", element: <BlockRobots />, isPrivate: true},
    { path: "/search-block-robots", element: <SearchBlockRobots />, isPrivate: true },

    // ---------------- SATELLITE & AGRI ----------------
    { path: "/satellite-map", element: <SatelliteMap />, isPrivate: true },
    { path: "/satellite-data", element: <SatelliteData />, isPrivate: true },
    { path: "/agri-field-map", element: <AgriFieldMap />, isPrivate: true },
    { path: "/agri-field-maping", element: <AgriFieldMaping />, isPrivate: true },
    { path: "/bhu-agri-map", element: <BhuAgriMap />, isPrivate: true },
    { path: "/agri-dashboard", element: <AgriDashboard />, isPrivate: true },
    { path: "/bhu-pilot", element: <BhuPilot />, isPrivate: true },
    { path: "/robot-control", element: <RobotControl />, isPrivate: true },
    { path: "/cam-viewer", element: <PiViewer />, isPrivate: true },
    { path: "/broadcaster", element: <Broadcaster />, isPrivate: true },
    // ---------------- TASKS / FIELDS ----------------
    { path: "/robot-task-schedule", element: <RobotTaskSchedule />, isPrivate: true},
    { path: "/robot-task-fields", element: <RobotTaskFields />, isPrivate: true},
    { path: "/field-rows-map", element: <FieldRowsMap />, isPrivate: true},

    // ---------------- ADMIN / FILES ----------------
    { path: "/upload-files", element: <UploadFiles />, isPrivate: true },
    { path: "/file-uploader", element: <FileUploader />, isPrivate: true },
];

export default AppRoutes;
